'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegisteredLeadsActionTypes = (0, _keyMirror2.default)({
  REQUESTED_REGISTERED_LEADS: null,
  RECEIVED_REGISTERED_LEADS_SUCCESS: null,
  RECEIVED_REGISTERED_LEADS_FAILED: null,

  REQUESTED_REGISTER_NEW_LEAD: null,
  REQUESTED_REGISTER_NEW_LEAD_SUCCESS: null,
  REQUESTED_REGISTER_NEW_LEAD_FAILED: null
});

exports.default = RegisteredLeadsActionTypes;
module.exports = exports['default'];